<script lang="ts">
  import { defineComponent } from "vue";
  import FicheSubscription from '@/generated/fiches/FicheSubscription.vue';
  export default defineComponent({
    extends: FicheSubscription,
    components: {}
})
</script>
